(() => {
 'use strict';
 const $=id=>document.getElementById(id),R=window.VaultRules;
 let current=[],draft=false,busy=false;
 function node(tag,text){const n=document.createElement(tag);if(text!==undefined)n.textContent=text;return n;}
 function table(id,items,total){
  const t=node('table'),head=node('thead'),hr=node('tr');
  for(const title of ['Type','Family','Height','Quantity']){const th=node('th',title);th.scope='col';hr.append(th);}head.append(hr);t.append(head);
  const body=node('tbody');for(const item of items){const row=node('tr');for(const value of [item.type,item.family,item.height+'U',item.quantity])row.append(node('td',value));body.append(row);}t.append(body);
  const foot=node('tfoot'),row=node('tr'),label=node('th','Total');label.colSpan=3;label.scope='row';row.append(label,node('td',total));foot.append(row);t.append(foot);$(id).replaceChildren(t);
 }
 function buttons(){for(const id of ['download-stack','print-parts'])$(id).disabled=busy||draft||!current.length;}
 function render(layers,hasDraft){
  current=JSON.parse(JSON.stringify(layers));draft=hasDraft;$('build-output').hidden=!layers.length;
  const list=R.partsList(layers);
  $('parts-totals').textContent=`${list.layerCount} layers · ${list.moduleCount} modules · ${list.facadeCount} facades`;
  table('module-list',list.modules,list.moduleCount);table('facade-list',list.facades,list.facadeCount);
  if(!busy)$('output-status').textContent=draft?'Finish or cancel the current layer to download or print. Counts show confirmed layers only.':'';
  buttons();
 }
 async function makePNG(layers,finish){
  const C=window.VaultFacadeCalibration,width=C.stackWidths[layers[0].layout],gap=C.moduleGapMm*C.pixelsPerMm,padding=32;
  const rows=[...layers].reverse().map(layer=>{
   const columns=R.layouts[layer.layout].map((family,i)=>layer.facades[i].map(unit=>window.VaultFacadeInfo(layer.type,family,unit)));
   const widths=columns.map(parts=>Math.max(...parts.map(p=>p.width)));
   return {columns,widths,height:Math.max(...columns.map(parts=>parts.reduce((n,p)=>n+p.height,0)))};
  });
  const height=Math.ceil(rows.reduce((n,row)=>n+row.height,0)+gap*(rows.length-1)+padding*2);
  if(height>32767||(width+padding*2)*height>60000000)throw Error('This stack is too tall for a single PNG. Please export a smaller build.');
  const sources=new Map(rows.flatMap(row=>row.columns.flatMap(parts=>parts.map(p=>[p.src,p]))));
  const images=new Map();await Promise.all([...sources].map(async ([src,info])=>{
   if(!src)throw Error('A facade image is missing. Please check the build before exporting.');
   try{const result=await window.VaultFacadeFinish.render(info,finish);images.set(src,result.image);}catch{throw Error('The selected facade finish could not load. Refresh and try again, or choose Show original.');}
  }));
  const canvas=document.createElement('canvas');canvas.width=width+padding*2;canvas.height=height;
  const ctx=canvas.getContext('2d');if(!ctx)throw Error('Image export is unavailable in this browser.');
  let y=padding;
  for(const row of rows){let x=padding+(width-row.widths.reduce((a,b)=>a+b,0))/2;
   row.columns.forEach((parts,i)=>{let py=y;for(const p of parts){ctx.drawImage(images.get(p.src),p.x,p.y,p.width,p.height,x+(row.widths[i]-p.width)/2,py,p.width,p.height);py+=p.height;}x+=row.widths[i];});
   y+=row.height+gap;
  }
  return new Promise((resolve,reject)=>canvas.toBlob(blob=>blob?resolve(blob):reject(Error('Could not create the PNG. Please try again.')),'image/png'));
 }
 $('download-stack').addEventListener('click',async()=>{
  if(draft||busy||!current.length)return;
  const snapshot=JSON.parse(JSON.stringify(current)),list=R.partsList(snapshot),finish=window.VaultFacadeFinish.mode;busy=true;buttons();$('output-status').textContent='Preparing your stack image…';
  try{
   const blob=await makePNG(snapshot,finish),url=URL.createObjectURL(blob),link=node('a');link.href=url;link.download=`vault-stack-${list.moduleCount}-modules-${list.facadeCount}-facades.png`;
   document.body.append(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),60000);
   $('output-status').textContent=`PNG download started · ${finish==='studio'?'studio silver':'original finish'}. The image includes the assembled stack only.`;
  }catch(error){$('output-status').textContent=error.message;}finally{busy=false;buttons();}
 });
 $('print-parts').addEventListener('click',()=>{if(!draft&&!busy&&current.length)window.print();});
 window.VaultOutput={render};
})();
